import React, { useState } from "react";
import { Link } from "react-router-dom";
// services
import * as Service from "../../services/Service.js";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Input,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  FormFeedback,
  FormText,
  FormGroup,
  Label,
} from "reactstrap";

import swal from "sweetalert";

// core components

const regex =
  /^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/;

function SignUp(props) {
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setconfirmPasswordShown] = useState(false);
  const [firstFocus, setFirstFocus] = React.useState(false);
  const [lastFocus, setLastFocus] = React.useState(false);
  const [loginNameFocus, setLoginNameFocus] = React.useState(false);
  const [emailFocus, setEmailFocus] = React.useState(false);
  const [designationFocus, setDesignationFocus] = React.useState(false);
  const [passwordFocus, setPasswordFocus] = React.useState(false);
  const [confirmPasswordFocus, setConfirmPasswordFocus] = React.useState(false);
  const [langCodeFocus, setLangCodeFocus] = React.useState(false);

  const [Language, setLangguage] = React.useState(true);
  const [Facility, setFacility] = React.useState(true);

  const [languageList, setLanguageList] = React.useState([]);
  const [FacilityList, setFacilityList] = React.useState([]);

  const [state, setState] = React.useState({
    firstName: "",
    lastName: "",
    loginname: "",
    email: "",
    designation: "",
    password: "",
    confirmPassword: "",
    service: Service,
    LangCode: "fr_FR",
    FacilityId: "",
  });

  if (Language) {
    state.service.default
      .postApi("source/language_combo.php")
      .then((res) => {
        setLanguageList(res);
        setLangguage(false);
      })
      .catch((err) => {});
  }

  if (Facility) {
    state.service.default
      .postApi("source/facility_combo.php")
      .then((res) => {
        setFacilityList(res);
        setFacility(false);
      })
      .catch((err) => {});
  }

  React.useEffect(() => {}, []);

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const submit = (e) => {
    e.preventDefault();
    if (
      state.firstName.length > 0 &&
      state.lastName.length > 0 &&
      state.loginname.length > 0 &&
      state.email.length > 0 &&
      state.designation.length > 0 &&
      state.password.length > 0 &&
      state.confirmPassword.length > 0 &&
      state.LangCode.length > 0
    ) {
      if (!regex.test(state.email)) {
        swal("Oops Error!", "Your email is not valid!", "error");
      } else if (state.password !== state.confirmPassword) {
        swal("Oops Error!", "Your Password is not same!", "error");
      } else if (state.loginname.indexOf(" ") >= 0) {
        swal(
          "Oops Error!",
          "White space is not allowed in login name.",
          "error"
        );
      } else {
        // swal("Success!", "", "success");
        const body = {
          name: state.firstName + " " + state.lastName,
          loginname: state.loginname,
          email: state.email,
          password: state.password,
          designation: state.designation,
          role: "User",
          LangCode: state.LangCode,
          FacilityId: state.FacilityId,
        };
        state.service.default
          .postApi("source/register.php", body)
          .then((res) => {
            if (res.success == 1) {
              swal("Success!", `${res.message}`, "success");
              props.history.push("/login");
            } else if (res.success == 0) {
              swal("Error!", `${res.message}`, "error");
            }
          })
          .catch((err) => {
            swal("Error!", `${err}`, "error");
          });
      }
    } else {
      swal("Oops Error!", "Please fill all required fields", "error");
    }
  };

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const toggleConfirmPasswordVisiblity = () => {
    setconfirmPasswordShown(confirmPasswordShown ? false : true);
  };
  return (
    <>
      <div
        className="section signup-top-padding"
        style={{
          backgroundImage: "url(" + require("assets/img/bg8.jpg") + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center",
          minHeight: "753px",
        }}
      >
        <Container>
          <Row>
            <Card className="card-signup" data-background-color="blue">
              <Form action="" className="form" method="">
                <CardHeader className="text-center">
                  <CardTitle className="title-up" tag="h3">
                    Sign Up
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <InputGroup
                    className={
                      "no-border" + (firstFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        <i className="now-ui-icons text_caps-small"></i>
                      </InputGroupText>
                    <Input
                      invalid={state.firstNameValidate}
                      placeholder="*First Name..."
                      name="firstName"
                      onChange={(evt) => handleChange(evt)}
                      type="text"
                      onFocus={() => setFirstFocus(true)}
                      onBlur={() => setFirstFocus(false)}
                    ></Input>
                    {state.firstNameValidate ? (
                      <FormFeedback invalid>
                        *This is a required field
                      </FormFeedback>
                    ) : null}
                  </InputGroup>

                  <InputGroup
                    className={
                      "no-border" + (lastFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        <i className="now-ui-icons text_caps-small"></i>
                      </InputGroupText>
                    <Input
                      invalid={state.lastNameValidate}
                      placeholder="*Last Name..."
                      type="text"
                      name="lastName"
                      onChange={(evt) => handleChange(evt)}
                      onFocus={() => setLastFocus(true)}
                      onBlur={() => setLastFocus(false)}
                    ></Input>
                    {state.lastNameValidate ? (
                      <FormFeedback invalid>
                        *This is a required field
                      </FormFeedback>
                    ) : null}
                  </InputGroup>

                  <InputGroup
                    className={
                      "no-border" + (loginNameFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        <i className="now-ui-icons users_circle-08"></i>
                      </InputGroupText>
                    <Input
                      invalid={state.loginNameValidate}
                      placeholder="*Login Name..."
                      type="text"
                      name="loginname"
                      onChange={(evt) => handleChange(evt)}
                      onFocus={() => setLoginNameFocus(true)}
                      onBlur={() => setLoginNameFocus(false)}
                    ></Input>
                    {state.loginNameValidate ? (
                      <FormFeedback invalid>
                        *This is a required field
                      </FormFeedback>
                    ) : null}
                  </InputGroup>

                  <InputGroup
                    className={
                      "no-border" + (emailFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        <i className="now-ui-icons ui-1_email-85"></i>
                      </InputGroupText>
                    <Input
                      invalid={state.emailValidate}
                      placeholder="*Email..."
                      type="text"
                      name="email"
                      onChange={(evt) => handleChange(evt)}
                      onFocus={() => setEmailFocus(true)}
                      onBlur={() => setEmailFocus(false)}
                    ></Input>
                    {state.emailValidate ? (
                      <FormFeedback invalid>
                        *This is a required field
                      </FormFeedback>
                    ) : null}
                  </InputGroup>

                  <InputGroup
                    className={
                      "no-border" +
                      (designationFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        <i className="now-ui-icons business_briefcase-24"></i>
                      </InputGroupText>
                    <Input
                      invalid={state.designationValidate}
                      placeholder="*Designation..."
                      type="text"
                      name="designation"
                      onChange={(evt) => handleChange(evt)}
                      onFocus={() => setDesignationFocus(true)}
                      onBlur={() => setDesignationFocus(false)}
                    ></Input>
                    {state.designationValidate ? (
                      <FormFeedback invalid>
                        *This is a required field
                      </FormFeedback>
                    ) : null}
                  </InputGroup>

                  <InputGroup
                    className={
                      "no-border" + (passwordFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        <i className="now-ui-icons ui-1_lock-circle-open"></i>
                      </InputGroupText>
                    <Input
                      invalid={state.passwordValidate}
                      placeholder="*Password..."
                      name="password"
                      onChange={(evt) => handleChange(evt)}
                      type={passwordShown ? "text" : "password"}
                      onFocus={() => setPasswordFocus(true)}
                      onBlur={() => setPasswordFocus(false)}
                    ></Input>
                    {state.passwordValidate ? (
                      <FormFeedback invalid>
                        *This is a required field
                      </FormFeedback>
                    ) : null}
                      <InputGroupText className="password-eye">
                        <i
                          onClick={togglePasswordVisiblity}
                          className="fa fa-eye"
                          aria-hidden="true"
                        ></i>
                      </InputGroupText>
                  </InputGroup>

                  <InputGroup
                    className={
                      "no-border" +
                      (confirmPasswordFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        <i className="now-ui-icons ui-1_lock-circle-open"></i>
                      </InputGroupText>
                    <Input
                      invalid={state.confirmPasswordValidate}
                      placeholder="*Confirm Password..."
                      name="confirmPassword"
                      onChange={(evt) => handleChange(evt)}
                      type={confirmPasswordShown ? "text" : "password"}
                      onFocus={() => setConfirmPasswordFocus(true)}
                      onBlur={() => setConfirmPasswordFocus(false)}
                    ></Input>
                    {state.confirmPasswordValidate ? (
                      <FormFeedback invalid>
                        *This is a required field
                      </FormFeedback>
                    ) : null}
                      <InputGroupText className="password-eye">
                        <i
                          onClick={toggleConfirmPasswordVisiblity}
                          className="fa fa-eye"
                          aria-hidden="true"
                        ></i>
                      </InputGroupText>
                  </InputGroup>

                  {/* ===================*/}
                  <InputGroup
                    className={
                      "no-border" + (langCodeFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        <i className="now-ui-icons objects_globe"></i>
                      </InputGroupText>
                    <Input
                      invalid={state.langCodeValidate}
                      type="select"
                      name="LangCode"
                      value={state.LangCode || "fr_FR"}
                      onChange={(evt) => handleChange(evt)}
                      onFocus={() => setLangCodeFocus(true)}
                      onBlur={() => setLangCodeFocus(false)}
                    >
                      <option value="">*Select Language</option>
                      {languageList.map((item, index) => {
                        return (
                          <option key={item.LangCode} value={item.LangCode}>{item.LangName}</option>
                        );
                      })}
                    </Input>
                    {state.langCodeValidate ? (
                      <FormFeedback invalid>
                        *This is a required field
                      </FormFeedback>
                    ) : null}
                  </InputGroup>
                  {/* ===================*/}

                  {/* ===================*/}
                  <InputGroup className={"no-border"}>
                      <InputGroupText>
                        <i className="fa fa-building"></i>
                      </InputGroupText>
                    <Input
                      type="select"
                      name="FacilityId"
                      onChange={(evt) => handleChange(evt)}
                    >
                      <option value="">Select Facility</option>
                      {FacilityList.map((item, index) => {
                        return (
                          <option key={item.FacilityId} value={item.FacilityId}>
                            {item.FacilityName}
                          </option>
                        );
                      })}
                    </Input>
                  </InputGroup>
                  {/* ===================*/}
                </CardBody>
                <CardFooter className="text-center">
                  <Button
                    className="btn-neutral btn-round"
                    color="info"
                    onClick={(e) => submit(e)}
                    size="lg"
                  >
                    Register
                  </Button>
                </CardFooter>
              </Form>
            </Card>
          </Row>
          <div className="col text-center">
            <Button
              className="btn-round btn-white bg_white"
              to="/login"
              outline
              size="lg"
              tag={Link}>
              View Login Page
            </Button>
          </div>
        </Container>
      </div>
    </>
  );
}

export default SignUp;
